import { render } from "./facebook-button.vue?vue&type=template&id=7e38eb27&scoped=true"
import script from "./facebook-button.vue?vue&type=script&lang=js"
export * from "./facebook-button.vue?vue&type=script&lang=js"

import "./facebook-button.vue?vue&type=style&index=0&id=7e38eb27&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e38eb27"]])

export default __exports__